
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'bs-loader',
    props: {
        color: {
            type: String as PropType<'royal-blue' | 'currentColor'>,
            default: 'royal-blue'
        }
    }
})
